export function title(value: string): string {
	if (!value) return "";
	return value.replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())));
}